import LinkPage from 'organization/Event/Services/Apps/ClickFunnels/LinkPage'
import {
  BaseIntegration,
  CLICK_FUNNELS,
  useServices,
} from 'organization/Event/Services/ServicesProvider'
import React from 'react'
import {useQueryParams} from 'lib/url'
import AuthPage from 'organization/Event/Services/Apps/ClickFunnels/AuthPage'
import Config from 'organization/Event/Services/Apps/ClickFunnels/Config'
import {Tag} from 'organization/Event/Services/Apps/ClickFunnels/Config/Tags'
import {Group} from 'organization/Event/Services/Apps/ClickFunnels/Config/Groups/group'
import {ClickFunnelsField} from 'organization/Event/Services/Apps/ClickFunnels/Config/Fields/AutocompleteFields'

export type ClickFunnelsIntegration = BaseIntegration & {
  service: typeof CLICK_FUNNELS
  tags: Tag[]
  groups: Group[]
  login_field_id: string | null
  login_field_key: string | null
  login_field_label: string | null
  login_field_type: string | null
  imported_at: string | null
  has_set_import_tag: boolean
}

export type LoginField = ClickFunnelsField

export default function ClickFunnels() {
  const {code} = useQueryParams()
  const {isLinked} = useServices()
  const showConfig = isLinked(CLICK_FUNNELS)

  if (showConfig) {
    return <Config />
  }

  if (code) {
    return <AuthPage authCode={code} />
  }

  return <LinkPage />
}
